export default {
  id: 'sale.yearMakeModel',
  name: 'sale.yearMakeModel',
  displayName: 'Year Make Model',
  valueType: 'string',
  objectType: 'sale',
  get: obj => {
    const {
      year,
      make,
      model
    } = obj?.data?.vehicle || {};
    return `${year ? `${year} ` : ''}${make ? `${make} ` : ''}${model || ''}`;
  }
};